export enum WebSocketEvent {
  MESSAGE_CREATED = "comment.created",
  MESSAGE_DELETED = "comment.deleted",
  MESSAGE_UPDATED = "comment.updated",
  BUG_UPDATED = "bug.updated",
  BUG_CREATED = "bug.created",
  BUG_TYPING = "bug.typing",
  BOT_STARTFEEDBACKFLOW = "bot.startfeedbackflow",
  BOT_OPENLINK = "bot.openlink",
  BOT_OPENTICKET = "bot.openticket",
  BOT_WRITTING = "bot.writting",
  BOT_TOOL = "bot.tool",
  BOT_TOOL_EXECUTE = "bot.tool.execute",
  CHECKLIST_UPDATED = "checklist.updated",
  CUSTOMACTION_RUN = "customaction.run",
  VOICE_CALL_ENDED = "voice.call.ended",
  VOICE_CAPTION = "voice.caption",
  VOICE_HOLD = "voice.hold",
}

export enum WebSocketDataContentType {
  MESSAGE = "MESSAGE",
  TICKET = "TICKET",
  TYPING = "TYPING",
  BOT = "BOT",
  CHECKLIST = "CHECKLIST",
}

export type WebSocketEventData = {
  contentType: WebSocketDataContentType;
  action: WebSocketEvent;
  actionID: string;
  parentID: string;
  actionData?: any;
};

export type PreparedWebSocketEventData = {
  contentType: WebSocketDataContentType;
  action: WebSocketEvent;
  actionID: string;
  parentID: string;
};
